import React from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "fe-shared/src/components";
import { TireMaterialConfig } from "fe-shared/src/types/domain";

import styles from "./CollectionInfoTooltip.module.scss";

interface Props {
  materials: TireMaterialConfig[];
}

const CollectionInfoTooltip = ({ materials }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip wrapperClassName={styles.tooltipContainer}>
      <label
        htmlFor="collection-info-helper-info"
        className={styles.tooltipSectionTitle}
      >
        {t(
          "transactions.grid.createRetreadingTransaction.form.collectedInfoTooltip.title"
        )}
      </label>
      <table className={styles.tooltipTableBody}>
        <thead>
          <tr>
            <th className={styles.tooltipTableLabel}>
              {t(
                "transactions.grid.createRetreadingTransaction.form.collectedInfoTooltip.headerLabel"
              )}
            </th>
            <th className={styles.tooltipTableData}>
              <span>
                {t(
                  "transactions.grid.createRetreadingTransaction.form.collectedInfoTooltip.headerValues"
                )}
              </span>
            </th>
          </tr>
        </thead>
        <tbody className={styles.tooltipTableBody}>
          {materials.map((material) => {
            return (
              <tr key={`tooltip-info-${material.code}`}>
                <td className={styles.tooltipTableLabel}>{material.name}</td>
                <td className={styles.tooltipTableData}>
                  {material.standardWeight}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Tooltip>
  );
};

export default CollectionInfoTooltip;
